import React from "react";
import { updateFilesToUpload } from "@microdoing/shared/services/upload/actions";
import { getFilesToUpload } from "@microdoing/shared/services/upload/selectors";
import hasAudioExtension from "@microdoing/shared/utils/hasAudioExtension";
import hasVideoExtension from "@microdoing/shared/utils/hasVideoExtension";
import { Box } from "app/components/common";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import UploadPreview from "../../UploadPreview";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

export interface IUploadFilesScrollViewProps {
  isValidateRequesting?: boolean;
  isComingFromReflexiveAnalysis?: boolean;
}

export function UploadFilesScrollView({
  isValidateRequesting = true,
  isComingFromReflexiveAnalysis = false,
}: IUploadFilesScrollViewProps) {
  const filesToUpload = useSelector(getFilesToUpload);

  const dispatch = useDispatch();

  const handleCancelSelection = assetIndex => () => {
    const assets = filesToUpload.filter((asset, index) => index !== assetIndex);
    dispatch(updateFilesToUpload(assets));
  };

  return (
    <Box width="100%" overflow="visible">
      {filesToUpload?.length > 0 && (
        <ScrollView
          contentContainerStyle={{
            overflow: "visible",
            paddingTop: theme.spacing.xs,
          }}
          horizontal
          showsHorizontalScrollIndicator={false}
        >
          <Box
            alignItems="center"
            justifyContent="flex-start"
            flexDirection="row"
            overflow="visible"
          >
            {filesToUpload?.map((file, index) => {
              const {
                uri,
                preview,
                uploadProgress = 0,
                fileName,
                type,
                duration = 0,
              } = file || {};
              const isAudio = hasAudioExtension(uri, fileName);

              if (isAudio && isComingFromReflexiveAnalysis) {
                return;
              }
              return (
                <UploadPreview
                  isVideo={
                    hasVideoExtension(uri) ||
                    hasVideoExtension(fileName) ||
                    !!duration
                  }
                  isAudio={isAudio}
                  fileName={fileName}
                  key={index}
                  uri={uri}
                  preview={preview}
                  previewSize={isWebDesktop ? normalize(100) : normalize(50)}
                  uploadProgress={uploadProgress}
                  hasCancelButton={isValidateRequesting}
                  cancelSelection={handleCancelSelection(index)}
                  isComingFromReflexiveAnalysis
                />
              );
            })}
          </Box>
        </ScrollView>
      )}
    </Box>
  );
}
